export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(el, { offset: -72, duration: 1.5 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const scrollToTop = () => {
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(0, { duration: 1.4 });
  else window.scrollTo({ top: 0, behavior: "smooth" });
};
